import { Feature, MapBrowserEvent } from "ol";
import { Interaction } from "ol/interaction";
import { Pixel } from "ol/pixel";
import { highlightFeature, selectFeature } from "../mapa";
import { CLICKABLE_LAYER_ID, DECEASED_TAB_NO, ORNAMENT_TAB_NO, POPUPS_ENABLED_ID } from "./constants";
import { hidePopup, isPopupShown, showPopup } from "./popup";
import { isMobile } from "./utilities";


export default class SelectGraveInteraction extends Interaction {
    start:Pixel;

    constructor() {
        super();
        this.start = [0, 0];
    }

    handleEvent(mapBrowserEvent: MapBrowserEvent<any>): boolean {
        if (mapBrowserEvent.type == "pointerdown") {
            this.start = mapBrowserEvent.pixel;
        }

        if (mapBrowserEvent.originalEvent.target.matches(".control-container *")) {
            return true;
        }

        let selection = this.getGraveFeatureForPixel(mapBrowserEvent.pixel);
        let graveId = undefined;
        if (selection) {
            let ids = selection.get("graveIds");
            if (ids && ids.length > 0) {
                graveId = ids.join(" ");
            }
        }
        let cid = +(document.getElementById("cardCId") as HTMLInputElement)?.value;
        let popupsEnabled:boolean = this.getMap()?.get(POPUPS_ENABLED_ID) || false;

        switch (mapBrowserEvent.type) {
            case "dblclick":
                if (popupsEnabled && graveId && cid) {
                    showPopup(mapBrowserEvent.coordinate, { id: graveId, cid: cid });
                }
                selectFeature(selection, ORNAMENT_TAB_NO, mapBrowserEvent.coordinate);
                if (selection)
                    return false;
            break;
            case "pointermove":
                if (isMobile())
                    break;
                if (popupsEnabled) {
                    let id = { id: graveId, cid: cid };
                    if (mapBrowserEvent.originalEvent.target?.getAttribute("data-grave-identifier") && cid) {
                        id = { id: mapBrowserEvent.originalEvent.target.getAttribute("data-grave-identifier"), cid: cid};
                    }
                    if (id.id) {
                        showPopup(mapBrowserEvent.coordinate, id);
                        return true;
                    }
                }
                hidePopup();
            break;
            case "pointerup": // namiesto single clicku
                if (mapBrowserEvent.activePointers.length > 1)
                    break;
                let distSquared = Math.pow(mapBrowserEvent.pixel[1] - this.start[1], 2) + Math.pow(mapBrowserEvent.pixel[0] - this.start[0], 2);
                if (distSquared < 100) { // pohyb do 10 px povazujem za klik
                    if (isMobile() && popupsEnabled) {
                        if (!graveId) {
                            hidePopup();
                            highlightFeature(undefined);
                        }
                        if (popupsEnabled && graveId && cid) {
                            let id = { id: graveId, cid: cid };
                            if (isPopupShown(id)) {
                                selectFeature(selection, DECEASED_TAB_NO, mapBrowserEvent.coordinate);
                            } else {
                                showPopup(mapBrowserEvent.coordinate, id);
                            }
                        }
                        highlightFeature(selection);
                    } else {
                        selectFeature(selection, DECEASED_TAB_NO, mapBrowserEvent.coordinate);
                    }
                }
            break;
        }
        return true;
    }

    private getGraveFeatureForPixel(pixel: Pixel) {
        let result:Feature = undefined;
        this.getMap().forEachFeatureAtPixel(
            pixel, 
            function(f) {
                if (f.get("hrob") && (!result || +result.get("objectNumber")<+f.get("objectNumber")))
                    result = f as Feature;
            }, 
            {layerFilter: (l) => l.get("layerId") === CLICKABLE_LAYER_ID}
        );
        return result
    }
}